import { t } from 'i18next';

import ArrowRightLine from '@/assets/icons/arrow_right_line.svg?component';
import { Button } from '@/components/atoms/Buttons';
import { SvgIcon } from '@/components/atoms/SvgIcon/SvgIcon';

interface ViewButtonProps {
    trackingId: string;
    onClick: () => void;
}

/** The card header's way into the full page for what the card summarises. */
export default function ViewButton(props: ViewButtonProps) {
    const { trackingId, onClick } = props;

    return (
        <Button
            variant={'secondary'}
            trackingId={trackingId}
            onClick={onClick}
            iconEnd={
                <SvgIcon color="currentColor" icon={ArrowRightLine} size="custom" customSize={20} />
            }>
            {t('common.actions.view')}
        </Button>
    );
}
